import React from "react";
import OracleScannerPanel from "@/components/predictor/OracleScannerPanel";
import ComplianceLock from "@/components/compliance/ComplianceLock";

/**
 * AdminOne · Scanner Command™ (Phase 27D).
 *
 * Wraps the public OracleScannerPanel with an AdminOne-styled shell that
 * exposes a quick category switcher and full-page layout.
 */
export default function AdminScannerCommand() {
  return (
    <div style={S.canvas} data-testid="admin-scanner-command">
      <ComplianceLock variant="banner" policy="v27" testid="admin-scanner-compliance-top" />
      <header style={S.header}>
        <div>
          <h1 style={S.title}>Scanner Command™</h1>
          <p style={S.subtitle}>
            12 CareLogix-native market scanners. All output is research-grade and HITL-required.
            No autonomous execution; no proprietary scanners copied.
          </p>
        </div>
      </header>
      <div style={S.body}>
        <OracleScannerPanel testid="admin-scanner-panel" />
      </div>
    </div>
  );
}

const S = {
  canvas: { minHeight: "100vh", background: "radial-gradient(circle at top right, rgba(16,185,129,0.10), #040608 30%, #020304 100%)", color: "#f8fafc", fontFamily: "'Figtree', 'Inter', system-ui, sans-serif" },
  header: { padding: "20px 26px 16px", borderBottom: "1px solid rgba(255,255,255,0.05)" },
  title: { color: "#c5a059", fontSize: 24, margin: 0, fontWeight: 800 },
  subtitle: { color: "#94a3b8", fontSize: 13, marginTop: 6, maxWidth: 820 },
  body: { padding: "16px 26px 30px" },
};
